"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.probeNpmCacheSetup = exports.probeNpxCommand = exports.probeNpxArguments = void 0;
// A tag alone does not beat npm's prefer-offline setting. Request fresh
// registry metadata without changing the user's persistent npm config.
// Revalidation is not reinstallation: npx reuses a completed cached install
// when latest still resolves to the same artifact, even with a new pairing code.
exports.probeNpxArguments = [
    "--yes",
    "--prefer-online",
    "--prefer-offline=false",
    "--offline=false",
    // npm's maintenance warnings are not actions for the person pairing a Probe.
    // Keep errors and the launched CLI's own output; do not edit their npm config.
    "--loglevel=error",
    "--update-notifier=false",
    "@verset/probe-cli@latest",
];
exports.probeNpxCommand = `npx ${exports.probeNpxArguments.join(" ")}`;
// npx keys its install directory by package spec, not by the native module ABI.
// Scope this invocation's cache after selecting Node; leave global npm config alone.
// Keep this path stable across runs; neither the pairing code nor time belongs in it.
exports.probeNpmCacheSetup = 'export npm_config_cache="$HOME/.cache/verset-probe/node-$(node -p process.versions.modules)-$(node -p process.platform)-$(node -p process.arch)"';
